import { SKILL_TAG_CLOUD_TEXTS } from '../../data';

import '../../styles/Marquee/Marquee.scss';

function Row({ items, reverse }) {
  const doubled = [...items, ...items];
  return (
    <div className={`marquee__row${reverse ? ' marquee__row--reverse' : ''}`}>
      <ul className="marquee__track">
        {doubled.map((item, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${item}-${i}`} aria-hidden={i >= items.length ? 'true' : undefined}>
            <span className="marquee__star" aria-hidden="true">
              ✦
            </span>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}

/** Infinite scrolling strips of technologies. */
export default function Marquee() {
  const half = Math.ceil(SKILL_TAG_CLOUD_TEXTS.length / 2);
  return (
    <section className="marquee" aria-label="Technologies I work with">
      <Row items={SKILL_TAG_CLOUD_TEXTS.slice(0, half)} />
      <Row items={SKILL_TAG_CLOUD_TEXTS.slice(half)} reverse />
    </section>
  );
}
